<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="300"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="left"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('openEdit', { type: 'edit', row })"
            />
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="left"
          >
            <i class="el-icon-delete tool-btn" @click="$emit('del', row)" />
          </el-tooltip>
        </div>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
